/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { downloadWorkPackageStorageObjects } from '../fn/files/download-work-package-storage-objects';
import { DownloadWorkPackageStorageObjects$Params } from '../fn/files/download-work-package-storage-objects';
import { listWorkPackageStorageObjects } from '../fn/files/list-work-package-storage-objects';
import { ListWorkPackageStorageObjects$Params } from '../fn/files/list-work-package-storage-objects';
import { StorageObjectDtoPage } from '../models/storage-object-dto-page';

@Injectable({ providedIn: 'root' })
export class FilesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listWorkPackageStorageObjects()` */
  static readonly ListWorkPackageStorageObjectsPath = '/v0/files/work-packages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listWorkPackageStorageObjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackageStorageObjects$Response(params?: ListWorkPackageStorageObjects$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageObjectDtoPage>> {
    return listWorkPackageStorageObjects(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listWorkPackageStorageObjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackageStorageObjects(params?: ListWorkPackageStorageObjects$Params, context?: HttpContext): Observable<StorageObjectDtoPage> {
    return this.listWorkPackageStorageObjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<StorageObjectDtoPage>): StorageObjectDtoPage => r.body)
    );
  }

  /** Path part for operation `downloadWorkPackageStorageObjects()` */
  static readonly DownloadWorkPackageStorageObjectsPath = '/v0/files/work-packages/download';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadWorkPackageStorageObjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadWorkPackageStorageObjects$Response(params?: DownloadWorkPackageStorageObjects$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return downloadWorkPackageStorageObjects(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadWorkPackageStorageObjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadWorkPackageStorageObjects(params?: DownloadWorkPackageStorageObjects$Params, context?: HttpContext): Observable<any> {
    return this.downloadWorkPackageStorageObjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
